/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

/**
 * Form for editing a trusted workload issuer. Every field but id is optional; an omitted field is left unchanged.
 */
export type UpdateWorkloadIssuerForm = {
  /**
   * What the platform is and what runs on it, in the operator's words. Trimmed on write; blank clears it. At most 500 characters after trimming.
   */
  description?: string | undefined;
  /**
   * The workload issuer id.
   */
  id: string;
  /**
   * Where the issuer publishes the keys its assertions are signed with. Must be an https URL on a fully qualified domain name.
   */
  jwksUri?: string | undefined;
  /**
   * The label an operator works with. Unique within its tier.
   */
  name?: string | undefined;
  /**
   * Replaces the issuer's tags; an empty list clears them. Trimmed and de-duplicated on write, then limited to 40 tags of at most 64 characters each.
   */
  tags?: Array<string> | undefined;
};

/** @internal */
export type UpdateWorkloadIssuerForm$Outbound = {
  description?: string | undefined;
  id: string;
  jwks_uri?: string | undefined;
  name?: string | undefined;
  tags?: Array<string> | undefined;
};

/** @internal */
export const UpdateWorkloadIssuerForm$outboundSchema: z.ZodMiniType<
  UpdateWorkloadIssuerForm$Outbound,
  UpdateWorkloadIssuerForm
> = z.pipe(
  z.object({
    description: z.optional(z.string()),
    id: z.string(),
    jwksUri: z.optional(z.string()),
    name: z.optional(z.string()),
    tags: z.optional(z.array(z.string())),
  }),
  z.transform((v) => {
    return remap$(v, {
      jwksUri: "jwks_uri",
    });
  }),
);

export function updateWorkloadIssuerFormToJSON(
  updateWorkloadIssuerForm: UpdateWorkloadIssuerForm,
): string {
  return JSON.stringify(
    UpdateWorkloadIssuerForm$outboundSchema.parse(updateWorkloadIssuerForm),
  );
}
